<template>
  <ActionCard>
    <template v-slot:middle>
      <UiIcon
        class="text-success"
        icon="account_circle"
        width="130"
        height="130"
      />
    </template>
    <template v-slot:bottom>
      <span>{{ formattedStatus }}</span>
    </template>
  </ActionCard>
</template>
<script>
import { defineComponent } from "vue";
import ActionCard from "@/components/ui/action-card.vue";
import { PARTNER_STATUS_MAP } from "@/constants";
export default defineComponent({
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  components: {
    ActionCard,
  },
  computed: {
    formattedStatus() {
      return PARTNER_STATUS_MAP[this.partner.status] || this.partner.status;
    },
  },
});
</script>
